import { getPrice } from '../utils/apiServices';
import { takeLatest, put, call } from 'redux-saga/effects';

export const LOAD_PRICING = 'LOAD_PRICING';
export const SET_PRICING = 'SET_PRICING';
export const PRICING_ERROR = 'PRICING_ERROR';
import {
  DEFAULT_BASE_PAGE_COUNT,
  DEFAULT_TRADEBOOK_PAGE_COUNT,
} from '../common/PicabooConstants';
import { SHOW_ADD_TO_CART_MODAL } from './modals';

/**
 * Reducers
 */

const reducer = (state = null, action) => {
  switch (action.type) {
    case SET_PRICING:
      return action.pricing;
    case PRICING_ERROR:
      return { error: true, message: action.payload };
  }
  return state;
};

export function loadPricing(pageCount, forceReload = false) {
  return {
    type: LOAD_PRICING,
    pageCount,
    forceReload,
  };
}

export function setPricing(pageCount, pricing) {
  return {
    type: SET_PRICING,
    pageCount,
    pricing,
  };
}

export function* getPriceHandler({ pageCount, forceReload } = {}) {
  // Use call for better testability and consistent saga behavior
  const effectivePageCount = pageCount === undefined ? '' : pageCount;
  try {
    const priceObject = yield call(
      getPrice,
      effectivePageCount,
      'photo_books',
      forceReload,
    );
    if (priceObject) {
      yield put(setPricing(effectivePageCount, priceObject));
    }
  } catch (err) {
    // Surface pricing errors to the rest of the app
    yield put({ type: PRICING_ERROR, payload: err.message || String(err) });
  }
}

function* setupSagas() {
  yield takeLatest([LOAD_PRICING, SHOW_ADD_TO_CART_MODAL], getPriceHandler);
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
  saga: setupSagas,
};
